module.exports = __webpack_public_path__ + "img/2c4177c.webp";